import type { FaireProductEntity } from "../../entity_types/product";

export const p_25xbioun8c: FaireProductEntity = {
  token: "p_25xbioun8c",
  type: "product",
  name: "FOCUS SUPPORT | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a3ae0147e0bc01b1f619b7701a6322e4952ac3afdf805843cb6a5d58c06b94de.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64f38f4e394a5f01d99d0060af44b10af5ccb19ba9be7663ec6cb93a0120a265.png",
  ],
  priceDollars: 23.8,
  description:
    'This 100% pure, therapeutic grade essential oil blend promotes concentration and helps to increase mental focus as it grounds, calms, and stabilizes the mind.\n\nTO USE: Apply desired amount onto inner wrists, forehead, or behind ears as needed.\n\nINGREDIENTS: ORGANIC UNREFINED COLD PRESSED AVOCADO OIL, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: CEDARWOOD, LAVENDER, FRANKINCENSE, LEMON, YLANG YLANG, ROSEMARY, PEPPERMINT, VETIVER.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\nDimension: 10 ml, 0.75" x 3.25" x 0.75".',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:26.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
